import React, { useState } from 'react';
import { LuScale } from 'react-icons/lu';
import { Plata } from './comun';

// "¿Lo hago en este período o en el que viene?" (12-oct-2026). Como el tramo baja el precio para TODOS
// los equipos del mes, a veces conviene pasar trabajos (que todavía están en plazo) al mes
// siguiente, o apurar unos pocos más para salir de la zona donde se cobra menos.
export default function DecisionMes({ d, plazo }) {
    const [cuentas, setCuentas] = useState(false);   // 28-oct-2026: el detalle, a un toque
    const r = d.recomendado;
    const fila = 'flex items-center justify-between gap-3 py-1.5 text-caption';
    let titulo, detalle, tono = 'neutro';
    if (d.pasarAlProximo > 0) {
        tono = 'alerta';
        titulo = `Cerrá el período en ${r.equipos} equipos y pasá ${d.pasarAlProximo} al que viene`;
        detalle = <>Cobrás <Plata v={r.cobras} className="font-black" /> + IVA en vez de <Plata v={d.todo.cobras} className="font-black" /> + IVA: <Plata v={d.diferencia} className="font-black" /> más, trabajando menos. Esos equipos los cobrás igual en el período siguiente.</>;
    } else if (d.quedaEnZona) {
        tono = 'alerta';
        titulo = `En este período quedás en ${r.equipos}: zona donde cobrás menos`;
        detalle = `Entre ${d.quedaEnZona.desde} y ${d.quedaEnZona.hasta} equipos se cobra menos que con ${d.quedaEnZona.frenarEn}. `
            + `Para salir hacen falta ${d.quedaEnZona.superarDesde}, y con lo que hay cargado y tu ritmo no llegás.`;
    } else if (r.equipos > d.minimo.equipos) {
        tono = 'bien';
        titulo = `Hacé todo lo que tenés: cerrás en ${r.equipos} equipos`;
        detalle = <>Cobrás <Plata v={r.cobras} className="font-black" /> + IVA. No hay nada que ganar pasando trabajos al período que viene.</>;
    } else {
        titulo = `Vas a cerrar en ${r.equipos} equipos`;
        detalle = <>Cobrás <Plata v={r.cobras} className="font-black" /> + IVA. Cuando entren más pedidos, esta cuenta se actualiza.</>;
    }
    const color = tono === 'alerta' ? 'border-[color:var(--warning-tx)] bg-[var(--warning-bg)]'
        : tono === 'bien' ? 'border-[color:var(--etapa-listo)] bg-card' : 'border-black/[0.07] dark:border-white/[0.07] bg-card';

    return (
        <div className={`p-3.5 rounded-2xl border-2 ${color} space-y-2`}>
            <p className="text-label font-black uppercase tracking-widest text-muted flex items-center gap-1.5"><LuScale size={13} /> ¿Lo hago en este período o en el que viene?</p>
            <p className="text-body-lg font-black text-ink leading-tight">{titulo}</p>
            <p className="text-caption text-ink leading-snug">{detalle}</p>
            <button type="button" onClick={() => setCuentas(v => !v)} className="text-caption font-bold text-secondary underline underline-offset-2">
                {cuentas ? 'Ocultar las cuentas' : 'Ver de dónde sale'}
            </button>
            {cuentas && <div className="pt-1 border-t border-black/[0.08] dark:border-white/[0.08]">
                <div className={fila}><span className="text-secondary">Hechos</span><b className="text-ink">{d.hechos}</b></div>
                {d.agendados > 0 && <div className={fila}><span className="text-secondary">Agendados para este período</span><b className="text-ink">{d.agendados}</b></div>}
                <div className={fila}><span className="text-secondary">Pedidos que vencen en este período (hay que hacerlos)</span><b className="text-ink">{d.obligatorios}</b></div>
                <div className={fila}><span className="text-secondary">Pedidos que pueden ir al período que viene</span><b className="text-ink">{d.opcionales}</b></div>
                <div className={fila}><span className="text-secondary">Te da el tiempo hasta</span><b className="text-ink">{d.tope} equipos ({d.ritmo}/día × {d.habilesRestantes} días hábiles)</b></div>
            </div>}
            {d.faltaTiempo && <p className="text-caption font-bold text-brand-red">Con tu ritmo no llegás a hacer todo lo pendiente antes de que cierre el período.</p>}
            {cuentas && d.zonas.length > 0 && (
                <p className="text-label text-muted">
                    Zonas donde cobrás menos: {d.zonas.map(z => `${z.desde}–${z.hasta}`).join(' · ')} equipos.
                    Plazo acordado: normales {plazo.normal} días hábiles, urgentes {plazo.urgente}.
                </p>
            )}
        </div>
    );
}
